import type {FileModel} from '../../../domain/File/File.model';

export abstract class UploadFileCmd {
  abstract exec(props: UploadFileCmd.Props): Promise<FileModel>;
}

export namespace UploadFileCmd {
  export type Props = FileModel.CreateConfig;
}
